import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import ProcessingQueue from "../users/ProcessingQueue";

const MainLayout1 = () => {
  // Load from localStorage if available, otherwise default to false
  // const [sidebarExpanded, setSidebarExpanded] = useState(() => {
  //   const storedState = localStorage.getItem("sidebarExpanded");
  //   return storedState ? JSON.parse(storedState) : false;
  // });

  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    const storedState = localStorage.getItem("sidebarExpanded");

    // If user already has a saved preference AND we're on desktop, use it.
    if (storedState !== null && window.innerWidth > 768) {
      return JSON.parse(storedState);
    }

    // Default behavior: Desktop open, Mobile closed
    return window.innerWidth > 768 ? true : false;
  });

  const location = useLocation();

  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth <= 768) {
  //       // 👇 Always close sidebar on mobile
  //       setSidebarExpanded(false);
  //     }
  //   };

  //   // Run once on mount
  //   handleResize();

  //   // Watch for window resizing
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // Persist sidebar state only if desktop

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Always collapse for mobile — don't store
        setSidebarExpanded(false);
      } else {
        // On desktop restore last saved state or default to open
        const stored = localStorage.getItem("sidebarExpanded");
        setSidebarExpanded(stored ? JSON.parse(stored) : true);
      }
    };

    // Run on mount
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth > 768) {
      localStorage.setItem("sidebarExpanded", JSON.stringify(sidebarExpanded));
    }
  }, [sidebarExpanded]);

  return (
    <div className="app">
      <Sidebar
        expanded={sidebarExpanded}
        toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
      />

      <div
        className={`main-content-wrapper ${
          sidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <nav className="topbar-wrapper">
          <TopBar
            sidebarExpanded={sidebarExpanded}
            toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
          />
        </nav>
        <main className="page-content">
          <Outlet />
        </main>
        {/* <ProcessingQueue/> */}
      </div>
    </div>
  );
};

export default MainLayout1;
